export enum CashRegisterStatus {
    Open = 1,
    Closed = 2
}